export const TEXTO_ACEPTACION =
  'Entiendo que este planificador organiza clases y no reemplaza mi formación técnica, la evaluación del grupo, la revisión del aparejo, las colchonetas, la asistencia ni mi criterio profesional.'

export const TEXTO_ALCANCE =
  'El Planificador Pro es una herramienta organizativa para docentes con formación previa. No certifica competencias, no evalúa instalaciones, no prescribe tratamientos y no enseña maniobras avanzadas. La profe responsable decide qué contenido es adecuado según la experiencia, el estado y las necesidades del grupo, además de las condiciones reales del espacio.'

export const PIE_IMPRESION =
  'Herramienta de planificación. La seguridad y adecuación de la clase dependen del criterio profesional y de las condiciones reales del espacio y del grupo'

export const SECCIONES_AYUDA: { titulo: string; texto: string }[] = [
  {
    titulo: 'Guardado local',
    texto:
      'Todo se guarda automáticamente en este dispositivo, dentro del navegador. No hay servidores, cuentas ni envío de información. Si borrás los datos del navegador o usás otro equipo, vas a necesitar un respaldo importado.'
  },
  {
    titulo: 'Crear y duplicar clases',
    texto:
      'El asistente de cuatro pasos organiza grupo, logística, bloques y revisión. Cualquier clase se puede duplicar: la copia recibe un identificador nuevo y mantiene la estructura editable, sin arrastrar la evaluación anterior.'
  },
  {
    titulo: 'Regresión, base y progresión',
    texto:
      'Cada ejercicio asignado admite una variante. En clases multinivel el objetivo principal necesita las tres opciones para que cada persona trabaje el mismo propósito. La progresión es opcional: no es premio ni obligación.'
  },
  {
    titulo: 'Respaldos',
    texto:
      'Desde Mis clases podés exportar un archivo JSON con clases, ejercicios personalizados y favoritos. Al importar podés combinar sin duplicar o reemplazar todos los datos; el reemplazo pide una confirmación escrita.'
  },
  {
    titulo: 'Impresión',
    texto:
      'La vista de impresión arma una hoja A4 en blanco y negro, sin navegación ni botones, con datos del grupo, bloques, ejercicios, advertencias y espacio para la evaluación posterior.'
  },
  {
    titulo: 'Advertencias',
    texto:
      'Las advertencias de trepa sin descenso, lateralidad, fatiga de agarre, altura en Introducción o nivel superior al elegido son recordatorios de revisión: no bloquean tus decisiones. Solo la aceptación inicial y la confirmación de contenidos dinámicos o caídas requieren una acción explícita.'
  },
  {
    titulo: 'Alcance',
    texto:
      'El catálogo base reúne 64 recursos de referencia con objetivo, prerrequisitos, regresión, progresión, clave docente y seguridad. No son instrucciones de montaje ni sustituyen la enseñanza presencial. Los recursos base no se editan: se copian y se personalizan.'
  }
]
